import React, { useEffect, useState } from "react";
import {
  Typography,
  Grid,
  Button,
  Box,
  Toolbar,
  Drawer,
  IconButton,
} from "@mui/material";
import AppBar from "@mui/material/AppBar";
import { useSelector, useDispatch } from "react-redux";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import "rc-time-picker/assets/index.css";
import { setSelectedAddress } from "../../../redux/publicReducer/actions";
import { useHistory, useRouteMatch } from "react-router-dom";
import Select from "react-select";
import { setModeOfPayment } from "../../../redux/cartReducer/actions";
import { fetchAndUpdateMealBalance, formatMealBalance } from "utils/mealBalance";
import axios from "axios";

import { Backdrop } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { Modal } from "react-bootstrap";
import "react-simple-keyboard/build/css/index.css";

import Fab from "@mui/material/Fab";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import FontSizeChanger from "react-font-size-changer";
import { useCookies } from "react-cookie";
import Swal from "sweetalert2";

const apiBaseURL = process.env.REACT_APP_API_BASE_URL;
const serverId = process.env.REACT_APP_SERVER_ID;
const siteId = process.env.REACT_APP_SITE_ID;
const storeId = process.env.REACT_APP_STORE_ID;
const enableRevenueCenter = process.env.REACT_APP_ENABLE_REVENUE_CENTER;
const enableKiosk = process.env.REACT_APP_ENABLE_EKIOSK;
const buttonColor = process.env.REACT_APP_BUTTON_COLOR;
const buttonText = process.env.REACT_APP_BUTTON_TEXT;
const serviceCharge = parseFloat(process.env.REACT_APP_SERVICE_FEE);

const SelectCreditCardDrawerSL = ({
  open,
  setOpen,
  getSubtotalPrice,
  getTotalTaxAmount,
  getTotalDiscount,
  getTotalPrice,
  deliveryCharge,
}) => {
  const [cookies, setCookie, removeCookie] = useCookies();
  const [userCards, setUserCards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [orderReady, setOrderReady] = useState(false);

  const [firstName, setFirstName] = useState(
    sessionStorage.getItem("firstName")
  );
  const [roomNumber, setRoomNumber] = useState(
    sessionStorage.getItem("roomNumber")
  );
  const { user } = useSelector((state) => state.public);
  const { selectedPayment, mealBalance, mealBalanceDollars } = useSelector((state) => state.cart);
  const mBalance = formatMealBalance(mealBalanceDollars);
  const { orderTimeSelectValue } = useSelector((state) => state.public);
  const match = useRouteMatch();
  const dispatch = useDispatch();
  const history = useHistory();
  const loginCustomerNumber = process.env.REACT_APP_LOGIN_CUSTOMER_NUMBER;

  // Checkout values - needed for Credit Card page
  const subTotal = getSubtotalPrice();
  const tax = getTotalTaxAmount();
  const discount = getTotalDiscount();
  const total = getTotalPrice();

  useEffect(() => {
    const loadMealBalance = async () => {
      const customer = await fetchAndUpdateMealBalance(
        dispatch,
        firstName,
        roomNumber,
        apiBaseURL,
        serverId,
        siteId,
        storeId
      );

      if (customer) {
        //change MealDollrar to Mealcount
        dispatch(
          setSelectedAddress({
            first_name: customer.FirstName,
            last_name: customer.LastName,
            phone: customer.Phone,
            email: customer.Email ? customer.Email : "",
            address: customer.Address1,
            address2: customer.Address2,
            city: customer.City,
            state: customer.State,
            zipCode: customer.Zip,
          })
        );
      }
    };

    if (firstName && roomNumber) {
      loadMealBalance();
    }
  }, [dispatch, firstName, roomNumber]);

  useEffect(() => {
    if (!open) {
      setOrderReady(false);
      return;
    }

    const orderId = sessionStorage.getItem("order_id");
    if (orderId && orderId !== "undefined") {
      setOrderReady(true);
      return;
    }

    const interval = setInterval(() => {
      const id = sessionStorage.getItem("order_id");
      if (id && id !== "undefined") {
        setOrderReady(true);
        clearInterval(interval);
      }
    }, 500);

    return () => clearInterval(interval);
  }, [open]);

  const sendOrder = () => {
    const orderId = sessionStorage.getItem("order_id");
    if (!orderId || orderId === "undefined") return;

    setLoading(true);
    const url =
      apiBaseURL +
      "/postpayment/send_econnect_sl/" +
      serverId +
      "/" +
      siteId +
      "/" +
      storeId +
      "/" +
      orderId;
    axios
      .get(url)
      .then((response) => {
        setLoading(false);
        if (response.data) {
          dispatch({
            type: "SET_CART",
            payload: [],
          });
          localStorage.clear();
          sessionStorage.removeItem("instructions");
          sessionStorage.removeItem("order_id");
          sessionStorage.removeItem("table");

          if (parseInt(enableKiosk) === 1) {
            Object.keys(cookies).forEach((cookieName) => {
              removeCookie(cookieName);
            });
            document.cookie.split(";").forEach((cookie) => {
              const name = cookie.split("=")[0].trim();
              document.cookie =
                name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
            });
          }

          Swal.fire({
            title: "Success!",
            text: "Transaction Approved!",
            icon: "success",
            showConfirmButton: true,
            confirmButtonText: "OK",
          }).then((result) => {
            // Clear the timeout when the user clicks on the OK button
            if (result.isConfirmed) {
              clearTimeout(autoCloseTimer);
            }
          });

          // Set a timeout to auto-dismiss the alert after 5 seconds
          let autoCloseTimer = setTimeout(() => {
            Swal.close();
          }, 5000);

          // Refresh meal balance after successful order
          if (firstName && roomNumber) {
            fetchAndUpdateMealBalance(
              dispatch,
              firstName,
              roomNumber,
              apiBaseURL,
              serverId,
              siteId,
              storeId
            );
          }

          if (enableRevenueCenter == 1) {
            history.push("/welcome");
          } else {
            if (parseInt(enableKiosk) === 1) {
              dispatch({
                type: "SET_CART",
                payload: [],
              });
              sessionStorage.clear();
              history.push("/");
            } else {
              history.push("/menu");
            }
          }
        } else {
          console.log(response);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <Drawer open={open} onClose={() => setOpen(false)} anchor="bottom">
      {parseInt(enableKiosk) === 0 && (
        <FontSizeChanger
          targets={["#target .content"]}
          onChange={(element, newValue, oldValue) => {
            console.log(element, newValue, oldValue);
          }}
          options={{
            stepSize: 2,
            range: 5,
          }}
          customButtons={{
            up: (
              <AppBar
                position="fixed"
                sx={{
                  width: "95px",
                  boxShadow: 0,
                  top: "auto",
                  bottom: 237.5,
                  backgroundColor: "transparent",
                  marginBottom: "50px",
                }}
              >
                <Toolbar>
                  <Box sx={{ flexGrow: 1 }} />
                  <IconButton>
                    <Fab
                      color="primary"
                      aria-hidden="true"
                      sx={{ backgroundColor: "#367c2b" }}
                    >
                      <AddCircleOutlineIcon />
                    </Fab>
                  </IconButton>
                </Toolbar>
              </AppBar>
            ),
            down: (
              <AppBar
                position="fixed"
                sx={{
                  width: "95px",
                  boxShadow: 0,
                  top: "auto",
                  bottom: 180,
                  backgroundColor: "transparent",
                  marginBottom: "50px",
                }}
              >
                <Toolbar>
                  <Box sx={{ flexGrow: 1 }} />
                  <IconButton>
                    <Fab
                      color="primary"
                      aria-hidden="true"
                      sx={{ backgroundColor: "#765F00" }}
                    >
                      <RemoveCircleOutlineIcon />
                    </Fab>
                  </IconButton>
                </Toolbar>
              </AppBar>
            ),
          }}
        />
      )}
      <Modal
        show={showModal}
        style={{ zIndex: "99999" }} // corrected style object
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-container"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Success!!!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Typography
            style={{
              fontWeight: 700,
              fontSize: enableKiosk === "0" ? "1.25rem" : "1.5rem",
            }}
            component="h4"
            variant="subtitle1"
          >
            Your Order has been Completed! Thank You.
          </Typography>
        </Modal.Body>
        <Modal.Footer>
          <Grid container justifyContent="center" className="content">
            <Button
              fullWidth
              color="primary"
              size="large"
              type="submit"
              variant="contained"
              style={{
                textTransform: "none",
                padding: "0rem 1rem",
                borderRadius: "10px",
                border: "1px solid #bebebe",
                backgroundColor: buttonColor,
                fontSize: "large",
                width: "50%",
              }}
              onClick={() => {
                setOpen(false);
                setShowModal(false);
                // setTimeout(() => {
                //   if (enableRevenueCenter == 1) {
                //     history.push("/welcome");
                //   } else {
                //     history.push("/menu");
                //   }
                // }, 500);
              }}
            >
              OK
            </Button>
          </Grid>
        </Modal.Footer>
      </Modal>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box id="target" padding="1rem" minHeight="80vh" position="relative">
        <Box height="40px" />
        <Typography
          style={{
            fontSize: enableKiosk === "0" ? "1.25rem" : "1.5rem",
          }}
          className="content"
          component="div"
          align="center"
        >
          Hey {firstName}, your
        </Typography>
        <Typography
          className="content"
          style={{
            fontWeight: 700,
            "text-align": "center",
            fontSize: enableKiosk === "0" ? "1.25rem" : "1.5rem",
          }}
        >
          {/*selectedPayment*/}
        </Typography>
        {userCards.map((card) => {
          return (
            <Box
              borderRadius="10px"
              border="1px solid #bebebe"
              padding="1rem 1rem"
              margin="1rem 0rem"
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              overflow="auto"
              onClick={() => {
                dispatch(setModeOfPayment(card));
                setOpen(false);
              }}
            >
              <Typography className="content">{card.MaskedAccount}</Typography>
            </Box>
          );
        })}

        {selectedPayment == "Credit Cards" && (
          <Button
            style={{
              cursor: "pointer",
              backgroundColor: buttonColor,
              color: buttonText,
              borderColor: buttonColor,
            }}
            fullWidth
            onClick={() => {
              history.push("/payment-wpay/", {
                subTotal,
                tax,
                discount,
                total,
                deliveryCharge,
                serviceCharge,
              });
            }}
          >
            use Credit Card
          </Button>
        )}

        {selectedPayment == "Meal Credit" && (
          <div>
            <Typography
              component="div"
              align="center"
              style={{
                fontSize: enableKiosk === "0" ? "1.25rem" : "1.5rem",
              }}
            >
              <b>Meal Credit Available: </b>
              <b>{mealBalance}</b>{" "}
            </Typography>
            <Typography
              component="div"
              align="center"
              style={{
                fontSize: enableKiosk === "0" ? "1.25rem" : "1.5rem",
              }}
            >
              <b>Current Balance: </b>
              <b>${mBalance}</b>{" "}
            </Typography>
            <br></br>
            <Grid container justifyContent="center" className="content">
              <Button
                fullWidth
                color="primary"
                size="large"
                type="submit"
                variant="contained"
                disabled={!orderReady}
                style={{
                  textTransform: "none",
                  padding: "0rem 1rem",
                  borderRadius: "10px",
                  border: "1px solid #bebebe",
                  backgroundColor: orderReady ? buttonColor : "#bebebe",
                  fontSize: enableKiosk === "0" ? "1.25rem" : "1.5rem",
                  width: "50%",
                }}
                onClick={() => {
                  sendOrder();
                }}
              >
                {orderReady ? "Submit Order" : (
                  <Box display="flex" alignItems="center" gap="8px">
                    <CircularProgress size={20} color="inherit" />
                    Preparing Order...
                  </Box>
                )}
              </Button>
            </Grid>
          </div>
        )}
      </Box>
    </Drawer>
  );
};

export default SelectCreditCardDrawerSL;
